import { render, staticRenderFns } from "./ProfileUpdateToDoDetails.vue?vue&type=template&id=088d0c0e"
import script from "./ProfileUpdateToDoDetails.vue?vue&type=script&lang=js"
export * from "./ProfileUpdateToDoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports